export default "__VITE_ASSET__Bd74qAq1__"